export enum ProcessHistoryState {
    OK = 0,
    WARNING = 1,
    FATAL_ERROR = 2,
    CANCELED = 3,
    RUNNING = 4,
    STATE5 = 5,
    NO_CHANGES = 6,
    FAILED = 7,
    PROCESSING_PENDING = 'processing_pending'
}

export const ProcessHistoryStateTitleMap = new Map<ProcessHistoryState, string>([
    [ProcessHistoryState.OK, 'Succeeded'],
    [ProcessHistoryState.WARNING, 'Warning'],
    [ProcessHistoryState.FATAL_ERROR, 'Error'],
    [ProcessHistoryState.CANCELED, 'Canceled'],
    [ProcessHistoryState.RUNNING, 'Running'],
    [ProcessHistoryState.NO_CHANGES, 'No Changes'],
    [ProcessHistoryState.FAILED, 'Failed'],
    [ProcessHistoryState.PROCESSING_PENDING, 'Processing Pending']
]);
